<template>
  <v-app>
    <div class="containerStyle" v-if="loading">
      <img id="loader" class="zoom" :src="img1"/>
    </div>
    <router-view/>
  </v-app>
</template>

<script>
import img1 from "./assets/LOGO USACH.png"
export default {
  name: 'App',

  data(){
    return{
      loading: this.$store.state.user.loading,
      img1: img1
    }
  },

   beforeCreate () {
     //console.log("process env")
     //console.log(process.env.ROOT_API)
    if (!this.$session.exists()) {
      this.$router.push('/')
      //console.log("no hay sesiones")
    }
    else{
      //console.log("si hay sesiones")
      //console.log(this.$session.getAll().name)
      
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f1f1f1!important;
  
}

.container{
  padding-top: 10px!important;
  padding-bottom: 7px!important; 
}

.containerStyle{
    background-color: black;
    position: fixed;
    z-index: 99999;
    width: 100%;
    height: 100%;
    padding: 20%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

#loader{
  position: relative;
  z-index: 999;
}

.zoom {
  animation: scale 2s linear infinite;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
  
@keyframes scale {
  50% {
    -webkit-transform:scale(1.2);
    -moz-transform:scale(1.2);
    -ms-transform:scale(1.2);
    -o-transform:scale(1.2);
    transform:scale(1.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue